import axios, { AxiosHeaders } from 'axios';
import { getAccessToken, getRefreshToken, setTokens, clearTokens } from '@src/service/tokenManager';
import { config } from '@uhg-abyss/web/tools/config';
import { attachApiTelemetry } from './apiTelemetry';

const API_BASE_URL = config('API_BASE_URL');

const api = axios.create({
  baseURL: API_BASE_URL,
});

// Request interceptor: attach access token + refresh token headers
api.interceptors.request.use(
  (config) => {
    const token = getAccessToken();
    const refreshToken = getRefreshToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    if (refreshToken) {
      config.headers['X-Refresh-Token'] = refreshToken;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor: read new tokens from response headers
api.interceptors.response.use(
  (response) => {
    const headers = response.headers;
    const newAccessToken = headers['x-new-access-token'];
    const newRefreshToken = headers['x-new-refresh-token'];

    if (newAccessToken) {
      const accessTokenStr = String(newAccessToken);
      const refreshTokenStr = newRefreshToken ? String(newRefreshToken) : undefined;
      sessionStorage.setItem('access_token', accessTokenStr);
      if (refreshTokenStr) {
        sessionStorage.setItem('refresh_token', refreshTokenStr);
      }
      console.log('Tokens refreshed successfully via backend filter');
    }

    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Token expired and backend couldn't refresh — redirect to login
      clearTokens();
      window.location.href = '/auth/sso';
    }
    return Promise.reject(error);
  }
);

attachApiTelemetry(api);

export const validateCase = async (caseId: string): Promise<any> => {
  const response = await api.get(`/validate/process/${caseId}`);
  return response.data;
};

export const saveValidation = async (
  caseId: string,
  section: 'triage' | 'summary',
  data: any
): Promise<any> => {
  const fileName = section === 'triage' ? 'triage_information' : 'descriptive_summary';
  const response = await api.put(`/validate/process/${caseId}`, { [fileName]: data });
  return response.data;
};
